const SizesUtils = require('../../../viscomjs/utils/SizesUtils');

const body = document.body;
let _root;
let _on = false;
let _elements = [];

function _init(root) {
    if (root === _root) {
        _on = true;
        return;
    }

    _destroy(_root);

    _root = root;
    _elements = [...root.querySelectorAll('[data-parallax]')];

    _elements.forEach(el => {
        const data = el.data || {};
        const center = el.querySelector('[data-parallax-center]');
        const spTgt = el.querySelector('[data-parallax-speed]');
        const tgtSelector = el.dataset.parallaxTarget;
        const tgt = document.querySelector(tgtSelector);

        data._updateParallax = () => {}

        if (spTgt && center) {
            const speed = parseFloat(spTgt.dataset.parallaxSpeed);
            if (!isNaN(speed)) {
                data._updateParallax = () => {
                    if (!_on) return;

                    const r = center.getBoundingClientRect();
                    const dx = r.left - SizesUtils.winOffsetWidth() / 2;
                    spTgt.style.transform = `translate3d(${dx * speed}px, 0, 0)`;
                }
                data.valid = true;
            }
        }

        if (tgt) {
            const bgId = el.dataset.bgId;

            data._updateParallax = () => {
                if (!_on) return;

                const w0 = SizesUtils.winOffsetWidth();
                let r = el.getBoundingClientRect();
                let x = r.left;

                if (r.width < 1) return;



                if (x + r.width < 0 || x > w0) return;

                // Set BG
                if (bgId) {
                    body.dataset.bgId = bgId;
                }

                // Update
                r = center.getBoundingClientRect();
                x = r.left;
                let s1 = 0.5 - 0.5 * (x - w0 / 2) / w0;
                tgt.style.opacity = 0.2 + 0.8 * s1;
                s1 = 1 + s1 * 0.3;
                tgt.style.transform = `scale(${s1})`;

            }

            data.valid = true;
        }

        el.data = data;
    });

    _on = true;
}

function _destroy(root) {
    if (root !== _root) return;
    _elements.splice(0, _elements.length);
    _root = null;
}

function _stop(root) {
    if (root !== _root) return;
    _on = false;
}

function _update() {
    if (!_on) return;

    _elements.forEach(el => {
        const data = el.data;
        if (!data || !data.valid) return;
        data._updateParallax();
    });
}

const ParallaxController = {};

ParallaxController.init = _init;
ParallaxController.stop = _stop;
ParallaxController.destroy = _destroy;
ParallaxController.update = _update;


module.exports = ParallaxController;


// WEBPACK FOOTER //
// ./js/viscom/boss/soccers/components/ParallaxController.js